"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchCamera = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchCamera = function SearchCamera() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "172",
    height: "104",
    viewBox: "0 0 172 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "clip-path": "url(#clip0_3302_67883)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M77.5 79C97.1061 79 113 63.1061 113 43.5C113 23.8939 97.1061 8 77.5 8C57.8939 8 42 23.8939 42 43.5C42 63.1061 57.8939 79 77.5 79Z",
    fill: "#13131C",
    fillOpacity: "0.2",
    stroke: "#13131C",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M77.5 72C93.2401 72 106 59.2401 106 43.5C106 27.7599 93.2401 15 77.5 15C61.7599 15 49 27.7599 49 43.5C49 59.2401 61.7599 72 77.5 72Z",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129 95L103 69",
    stroke: "#13131C",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "150.5",
    cy: "43.5",
    r: "2.5",
    stroke: "#D4D4D5",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "169.5",
    cy: "43.5",
    r: "2",
    fill: "#D4D4D5",
    stroke: "#D4D4D5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "2.5",
    cy: "43.5",
    r: "2",
    fill: "#D4D4D5",
    stroke: "#D4D4D5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "21.5",
    cy: "43.5",
    r: "2.5",
    fill: "white",
    stroke: "#D4D4D5",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3302_67883"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "104",
    height: "104",
    fill: "white",
    transform: "translate(34)"
  }))));
};
exports.SearchCamera = SearchCamera;